import React, { useEffect, useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { NavLink, useNavigate } from "react-router-dom";
// import { SubmitHandler } from "react-hook-form";
// import { useLoading } from "@/contexts/LoadingContext";
import { useDispatch, useSelector } from "react-redux";
import { setUser,  signUpUser } from "@/features/auth/UserSlice";
import { AppDispatch, RootState } from "@/store";
import { User } from "@/features/auth/types";
// import { setSubscriptionDetails } from "@/features/plans-and-subscription/subscriptionSlice";
// import { User } from "lucide-react";

interface FormValues {
    email: string;
    password: string;
}

interface FormErrors {
    email?: string;
    password?: string;
}

const labelStyle = "block text-left text-sm font-medium mb-2";
const errorStyle = "text-red-500 text-left text-xs mt-1";
const buttonStyle = "w-full text-lg font-semibold py-2 px-4 rounded-lg";

const SignUpForm: React.FC = () => {
    const [formValues, setFormValues] = useState<FormValues>({
        email: "",
        password: "",
    });
    const [formErrors, setFormErrors] = useState<FormErrors>({});
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const userDetails = useSelector(
  (state: RootState) => state.rootReducer.userReducer.user
);

useEffect(() => {
  if (userDetails && userDetails.questionnaireFilled === false) {
    console.log("line 42");
    navigate(`/chat/newOnboarding`);
  }
}, [userDetails]);
    // const [isChatbot, setIsChatBot] = useState<boolean>(true);

    const dispatch = useDispatch<AppDispatch>();
    // const { setLoading } = useLoading();
    const navigate = useNavigate();

    /* Handler function for email and password input change */
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });

        // Clear error when user starts typing
        if (formErrors[name as keyof FormErrors]) {
            setFormErrors({ ...formErrors, [name]: undefined });
        }
    };

    /* Function to validate email */
    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    /* Function to validate form */
    const validateForm = (): boolean => {
        const errors: FormErrors = {};

        if (!formValues.email) {
            errors.email = "Email is required";
        } else if (!validateEmail(formValues.email)) {
            errors.email = "Please enter a valid email";
        }

        if (!formValues.password) {
            errors.password = "Password is required";
        } else if (formValues.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    /* Handler function for login button */
    // const handleLogin = (e: React.FormEvent) => {
    //   e.preventDefault();
    //   if (validateForm()) {
    //     navigate(`/dashboard/buildmapper_agent`);
    //     console.log("Login with:", formValues);
    //   }
    // };

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formValues); // You can add your API call here
        if (validateForm()) {
            const credentials = {
                email: formValues.email,
                password: formValues.password,
                role: 1,
            };


            //  setLoading(true);
            dispatch(signUpUser(credentials))
                .then((result) => {
                    console.log("sign up result", result);

                    const user = result.payload as User;

                    if (user) {
                        dispatch(setUser(user));
                        // dispatch(toggleQuestion(user.questionnaireFilled));

                        // ✅ Navigate if questionnaire is not filled
                        // if (user.questionnaireFilled === false) {
                        //     navigate(`/chat/newOnboarding`);
                        // }
                    }
                })
                .finally(() => {
                    // setLoading(false);
                });



        }
    };

    /* Handler function for signup button */
    // const handleSignup = () => {
    //   if (validateForm()) {
    //     // Handle signup logic here
    //     console.log("Signup with:", formValues);
    //   }
    // };

    /* Function for toggling password visibility */
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    return (
        <main className="flex-grow flex flex-col items-center justify-center px-4">
            {/* Login/Signup form */}
            <div className="w-full max-w-[30rem] p-8">
                <h2 className="text-2xl font-semibold text-center mb-1">
                    Sign Up
                </h2>
                <form onSubmit={handleLogin}>
                    {/* Email field */}
                    <div className="mb-2">
                        <label htmlFor="email" className={labelStyle}>
                            Email
                        </label>
                        <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter Email"
                            value={formValues.email}
                            onChange={handleChange}
                            className={`w-full rounded-lg ${formErrors.email ? "border-red-500" : ""}`}
                        />
                        {formErrors.email && (
                            <p className={errorStyle}>{formErrors.email}</p>
                        )}
                    </div>

                    {/* Password field */}
                    <div className="mb-4">
                        <label htmlFor="password" className={labelStyle}>
                            Password
                        </label>
                        <div className="relative">
                            <Input
                                id="password"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                value={formValues.password}
                                onChange={handleChange}
                                className={`w-full pr-10 rounded-lg ${formErrors.password ? "border-red-500" : ""}`}
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 flex items-center pr-3"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? (
                                    <IoMdEyeOff className="h-6 w-6" fill="#828282" />
                                ) : (
                                    <IoMdEye className="h-6 w-6" fill="#828282" />
                                )}
                            </button>
                        </div>
                        {formErrors.password && (
                            <p className={errorStyle}>{formErrors.password}</p>
                        )}
                    </div>

                    {/* Login button */}
                    <Button
                        type="submit"
                        className={`${buttonStyle} bg-[#28af4a] hover:bg-[#28af4a]/90 text-white mb-4`}
                    >
                        Sign Up
                    </Button>
                </form>

                {/* Sign Up button */}
                {/* <Button
          variant="outline"
          className={`${buttonStyle} border-[#28af4a] !text-[#28af4a]`}
          onClick={handleSignup}
        >
          Sign Up
        </Button> */}

                {/* Forgot password */}
                <NavLink to="/auth/forget-password">
                    <p className="text-right text-sm font-normal mt-2 text-gray-600 hover:underline cursor-pointer hover:text-[#28af4a]">
                        Forgot your password?
                    </p>
                </NavLink>

                {/* OR separator */}
                {/* <div className="flex items-center my-6">
          <div className="w-full h-px flex-grow-0 bg-[#e0e0e0]" /> */}
                {/* <span className="px-3 text-[#828282] text-sm font-medium">OR</span> */}
                {/* <div className="w-full h-px flex-grow-0 bg-[#e0e0e0]" />
        </div> */}

                {/* Social login buttons */}
                {/* <div className="flex justify-center gap-6">
          <Button variant="outline" size="icon" className={socialStyle}>
            <img src={fbLogo} alt="facebook logo" />
          </Button>
          <Button variant="outline" size="icon" className={socialStyle}>
            <img src={googleLogo} alt="google logo" />
          </Button>
          <Button variant="outline" size="icon" className={socialStyle}>
            <img src={appleLogo} alt="apple logo" />
          </Button>
        </div> */}

                {/* Terms and conditions */}
                <p className="text-center text-sm font-normal mt-2 text-gray-600">
                    By signing in, you accept our{" "}
                    <a href="#" className="text-[#28af4a] hover:underline">
                        Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a href="#" className="text-[#28af4a] hover:underline">
                        Privacy Policy
                    </a>
                </p>
                  <p className="text-center text-sm font-normal mt-3 text-gray-600">
                  Already have an account?{" "}
                  <NavLink to="/auth/login" className="text-[#28af4a] hover:underline">
                     Sign In
                  </NavLink>
                </p>
            </div>
        </main>
    );
};

export default SignUpForm;
